import { render } from "./MPropack2Dtl.vue?vue&type=template&id=fdea3c3e"
import script from "./MPropack2Dtl.vue?vue&type=script&lang=js"
export * from "./MPropack2Dtl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__